import { getDeliveryOptions } from "@repo/apis/commerce-deliveryoptions-v2";
import { configureNextServerRequest } from "@repo/next-utils/next-server-request";

export type GetDeliveryAndReturnsProps = {
  requestInstance: ReturnType<typeof configureNextServerRequest>;
  countryData: {
    countryCode: string;
    storeCode: string;
    defaultLanguage: string;
    defaultCurrency: string;
  };
};

export const getDeliveryAndReturnsData = async ({
  requestInstance,
  countryData,
}: GetDeliveryAndReturnsProps) => {
  const { countryCode, storeCode, defaultLanguage, defaultCurrency } =
    countryData;

  return getDeliveryOptions({
    requestInstance,
    store: storeCode,
    country: countryCode,
    lang: defaultLanguage,
    currency: defaultCurrency,
  });
};
